import { createAction } from "redux-act";

export const PlaygroundGroupDeleteAction = createAction("Playground Group Delete");
export const PlaygroundGroupDeleteRequestAction = createAction("Playground Group Delete - Request");
export const PlaygroundGroupDeleteSuccessAction = createAction("Playground Group Delete - Success");
export const PlaygroundGroupDeleteFailedAction = createAction("Playground Group Delete - Failed");
